import React, { FC } from 'react';
import { Button, EmptyListWarning, GridFixed, Icon, Row } from '../../components';
import { dateFormat, dateTimeFormat } from '../../constants/date-format';
import { ExpertCertificate } from 'models/expert-certificates';
import { PaginationProps } from 'components/Pagination/Pagination';
import moment from 'moment';

interface Props {
    data: ExpertCertificate[];
    pagination: PaginationProps;
    setUpdate: (val: ExpertCertificate) => void;
}

export const CertificatesGrid: FC<Props> = ({ data, setUpdate }) => {
    const getGridData = (): Row[] =>
        data.map((item) => ({
            ...item,
            download: {
                additionalComponent:
                    !item.id || item.isDeleted ? (
                        ''
                    ) : (
                        <a
                            className="link"
                            href={`/api/GetCertificate/${item.id}/${item.userId}/certificate.pdf`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Download
                        </a>
                    ),
            },
            creationDate: moment(item.creationDate).format(dateTimeFormat),
            updateDate: moment(item.updateDate).format(dateTimeFormat),
            expiredDate: item.expiredDate ? moment(item.expiredDate).format(dateFormat) : '',
            isDeleted: {
                additionalComponent: (
                    <div className="study-center-test-statistics-grid__status-icon">
                        {item.isDeleted ? 'Да' : 'Нет'}
                    </div>
                ),
            },
            isExpired: {
                additionalComponent: (
                    <div className="study-center-test-statistics-grid__status-icon">
                        {item.isExpired ? 'Истёк' : 'Действителен'}
                    </div>
                ),
            },
            updateActions: {
                additionalComponent: (
                    <Button pSize="none" handleClick={() => setUpdate(item)}>
                        <Icon iconName="edit" />
                    </Button>
                ),
            },
        }));
    return data.length ? <GridFixed columns={getColumns()} rows={getGridData()} /> : <EmptyListWarning />;
};

const getColumns = () => ({
    creationDate: {
        value: 'Дата создания',
        columnSize: '200',
    },
    updateDate: {
        value: 'Дата обновления',
        columnSize: '200',
    },
    expiredDate: {
        value: 'Дата окончания',
        columnSize: '200',
    },
    isExpired: {
        value: 'Статус',
        columnSize: '100',
    },
    number: {
        value: 'Номер',
        columnSize: '200',
    },
    name: {
        value: 'Название',
        columnSize: '300',
    },
    ownerName: {
        value: 'Владелец',
        columnSize: '300',
    },
    userEmail: {
        value: 'Email',
        columnSize: '300',
    },
    download: {
        value: 'Скачать',
        columnSize: '200',
    },
    isDeleted: {
        value: 'Удалён',
        columnSize: '100',
    },
    updateActions: {
        value: '',
        columnSize: '100',
    },
});
